import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {getWindow} from 'ssr-window';
import IconChevronDown from '@spothero/icons/chevron-down';
import IconFacebookCircle from '@spothero/icons/facebook-circle';
import IconInstagramCircle from '@spothero/icons/instagram-circle';
import IconTwitterCircle from '@spothero/icons/twitter-circle';
import IconYoutubeCircle from '@spothero/icons/youtube-circle';
import IconTimes from '@spothero/icons/times';
import IconSpothero from '@spothero/icons/spothero';
import {Button} from '@spothero/ui/backlog';
import APIUtils from '@spothero/utils/api';
import BrandUtils from '@spothero/utils/brand';
import ContentAPI from 'api/content';
import AppStoreBadges from 'common/app-store-badges';
import Link from 'router/Link';

const window = getWindow();

export default class Footer extends Component {
    static propTypes = {
        className: PropTypes.string,
        isMonolith: PropTypes.bool,
        data: PropTypes.array,
        email: PropTypes.string,
    };
    static defaultProps = {
        data: [],
    };
    state = {
        isOpen: false,
        data: this.props.data,
    };

    constructor(props) {
        super(props);

        this._viewportLarge = BrandUtils.getBreakpoint('lg');
    }

    componentDidMount() {
        window.addEventListener('resize', this._onWindowResize);

        this._onWindowResize();

        if (!this.state.data.length) {
            this._loadData();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this._onWindowResize);

        if (this._dataLoader) {
            this._dataLoader.cancel();
            this._dataLoader = null;
        }
    }

    _onWindowResize = evt => {
        const windowWidth = window.innerWidth || document.body.clientWidth;

        if (windowWidth >= this._viewportLarge && this.state.isOpen) {
            this._onCloseClick();
        }
    };

    _onOpenClick = () => {
        this.setState({
            isOpen: true,
        });
    };

    _onCloseClick = () => {
        this.setState({
            isOpen: false,
        });
    };

    _onToggleClicked = () => {
        this.setState((prevState, props) => {
            return {
                isOpen: !prevState.isOpen,
            };
        });
    };

    async _loadData() {
        try {
            this._dataLoader = APIUtils.makeCancelable(ContentAPI.getFooter());

            const {
                data: {
                    data: {columns},
                },
            } = await this._dataLoader.promise;

            this.setState({
                data: columns,
            });
        } catch (error) {
            console.log('Error loading footer data: ', error); // eslint-disable-line no-console
        }

        this._dataLoader = null;
    }

    render() {
        const {className, isMonolith, email} = this.props;
        const {isOpen, data} = this.state;
        const classes = classNames(
            'Footer',
            {'Footer-open': isOpen},
            className
        );

        return (
            <>
                {isOpen && (
                    <div
                        className="Footer-shim shim"
                        onClick={this._onToggleClicked}
                    />
                )}
                <div className={classes}>
                    <div className="container">
                        <div className="Footer-column Footer-logos">
                            <div className="Footer-branding">
                                <Link
                                    className="Footer-brand"
                                    to="/"
                                    forceAnchor={isMonolith}
                                >
                                    <IconSpothero />
                                </Link>
                                <div className="Footer-parked">
                                    <p>
                                        40M+<small>Cars Parked</small>
                                    </p>
                                </div>
                            </div>
                            <div className="Footer-apps">
                                <AppStoreBadges email={email} />
                            </div>
                        </div>
                        <div className="Footer-column Footer-links">
                            {data.map((column, i) => (
                                <div key={i} className="Footer-link-column">
                                    <input
                                        id={`Footer-links-${i}`}
                                        className="Footer-link-toggle"
                                        type="checkbox"
                                    />
                                    <label
                                        className="Footer-link-heading"
                                        htmlFor={`Footer-links-${i}`}
                                    >
                                        {column.title}
                                        <IconChevronDown />
                                    </label>
                                    <ul>
                                        {column.items.map((item, j) => (
                                            <li key={j}>
                                                {item.url ? (
                                                    <Link
                                                        to={item.url}
                                                        forceAnchor={isMonolith}
                                                    >
                                                        {item.title}
                                                    </Link>
                                                ) : (
                                                    item.title
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>
                        <div className="Footer-column Footer-social">
                            <ul>
                                <li>
                                    <a
                                        href="https://www.facebook.com/SpotHero"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <IconFacebookCircle />
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="https://instagram.com/spothero"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <IconInstagramCircle />
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="https://twitter.com/SpotHero"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <IconTwitterCircle />
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="https://www.youtube.com/channel/UC6OwKRrIUj3dgVKWb2Z5MyQ"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <IconYoutubeCircle />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="Footer-copyright container">
                        <p>
                            <small>
                                SpotHero &copy;{new Date().getFullYear()}. All
                                Rights Reserved.
                            </small>
                        </p>
                    </div>
                    <Button
                        className="Footer-toggle"
                        onClick={this._onToggleClicked}
                    >
                        {isOpen ? (
                            <>
                                Close <IconTimes />
                            </>
                        ) : (
                            'Learn More'
                        )}
                    </Button>
                </div>
            </>
        );
    }
}
